import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Column, Transaction, Transfer } from '~/types';
import CopyButton from '~/components/CopyButton';

interface Props {
  children: Transaction | Transfer;
  column: Column;
}

const RowOptionsButton = ({ children: rowData }: Props) => {
  const classes = useStyles();
  const isTransaction = (data: Transaction | Transfer): data is Transaction =>
    'headTransactionId' in data;
  const transfer = (!isTransaction(rowData) ? rowData : {}) as Transfer;
  return (
    <Fragment>
      <CopyButton
        value={
          isTransaction(rowData)
            ? rowData?.headTransactionId || "It's seems that transaction hasn't 'headTransactionId'"
            : transfer?.transactionPublicId ||
              transfer?.transactionId ||
              "It's seems that transfer hasn't 'transactionId'"
        }
        classes={classes}
      />
    </Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    minWidth: 30,
    color: theme.palette.grey[600],
  },
  listItemText: {
    marginBottom: 0,
  },
  button: {
    padding: 3,
    color: theme.palette.grey[500],
  },
  icon: {
    fontSize: '1rem',
  },
}));

export default RowOptionsButton;
